import React, { useReducer } from 'react'

function reducer(state, action) {
  switch (action.type) {
    case 'events':
      console.log('got normal events')
      return { ...state, events: action.value, eventsLoader: false }
    case 'cancelledIntakes':
      console.log('got cancelledIntakes')
      return { ...state, cancelledIntakes: action.value, cancelledIntakeLoader: false }
    case 'availability':
      console.log('got availability intakes')
      return { ...state, availability: action.value, availabilityLoader: false }
    case 'filterType':
      return { ...state, filterType: action.value }
    case 'filterText':
      return { ...state, filterText: action.value }
    case 'selected':
      return { ...state, selected: action.value }
    case 'event':
      return { ...state, event: action.value }
    case 'eventField':
      return { ...state, selected: { ...state.selected, [action.key]: action.value } }
    case 'loadingReset':
      return {
        ...state, availabilityLoader: true,
        cancelledIntakeLoader: true,
        eventsLoader: true
      }
    default:
      return state
  }
}

const initialState = {
  events: {},
  availability: {},
  filterType: null,
  filterText: '',
  event: {},
  selected: null,
  cancelledIntakes: [],
  availabilityLoader: true,
  cancelledIntakeLoader: true,
  eventsLoader: true
}

export const ReducerContext = React.createContext(null)

export const wrap = (C) => (props) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  return (
    <ReducerContext.Provider value={{ state, dispatch }}>
      <C {...props} />
    </ReducerContext.Provider>
  )
}
